<template>
    <v-card
        flat
        tile
    >
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-card outlined>
                        <v-card-title>
                            <v-icon 
                                left
                                class="mr-2"
                            >
                                mdi-information-outline
                            </v-icon>
                            Geral
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="ID"
                                        :value="subscription.id"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Status"
                                        :value="$subscription.statusLabels[subscription.status] || subscription.status"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Data de Início"
                                        :value="$date.format(subscription.start_at)"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Data de Fim"
                                        :value="subscription.end_at ? $date.format(subscription.end_at) : 'N/A'"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Próxima Cobrança"
                                        :value="$date.format(subscription.next_billing_at)"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Intervalo"
                                        :value="`${subscription.interval_count} ${subscription.interval}`"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Parcelas"
                                        :value="subscription.installments || 'N/A'"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Código"
                                        :value="subscription.code || 'N/A'"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card 
                        v-if="subscription.plan"
                        outlined
                    >
                        <v-card-title>
                            <v-icon 
                                left
                                class="mr-2"
                            >
                                mdi-package-variant
                            </v-icon>
                            Plano
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col 
                                    cols="12" 
                                    md="4"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="ID"
                                        :value="subscription.plan.id"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="4"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Nome"
                                        :value="subscription.plan.name"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="4"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Código"
                                        :value="subscription.plan.code || 'N/A'"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card 
                        v-if="subscription.current_period"
                        outlined
                    >
                        <v-card-title>
                            <v-icon 
                                left
                                class="mr-2"
                            >
                                mdi-calendar-clock
                            </v-icon>
                            Período Atual
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="ID"
                                        :value="subscription.current_period.id"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Ciclo"
                                        :value="subscription.current_period.cycle"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Data de Cobrança"
                                        :value="$date.format(subscription.current_period.billing_at)"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Início"
                                        :value="$date.format(subscription.current_period.start_at)"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Fim"
                                        :value="$date.format(subscription.current_period.end_at)"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Duração (segundos)"
                                        :value="subscription.current_period.duration"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card outlined>
                        <v-card-title>
                            <v-icon 
                                left
                                class="mr-2"
                            >
                                mdi-clock-outline
                            </v-icon>
                            Timestamps
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Criado em"
                                        :value="$date.format(subscription.created_at)"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Atualizado em"
                                        :value="$date.format(subscription.updated_at)"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    v-if="subscription.cancel_at"
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Cancelado em"
                                        :value="$date.format(subscription.cancel_at)"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col 
                                    v-if="subscription.overdue_since"
                                    cols="12" 
                                    md="6"
                                >
                                    <v-text-field
                                        hide-details
                                        outlined
                                        label="Em atraso desde"
                                        :value="$date.format(subscription.overdue_since)"
                                        readonly
                                        variant="outlined"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props: {
        subscription: {
            type: Object,
            required: true,
        }
    },
}
</script>
